import { inject, Pipe, PipeTransform } from "@angular/core";
import { Store } from "@ngxs/store";
import { OrganizationState } from "@vp/data-access/organization";
import { Organization } from "@vp/models";
import { filterNullMap } from "@vp/shared/operators";
import { Observable } from "rxjs";
import { map, shareReplay } from "rxjs/operators";
@Pipe({
  name: "role",
  standalone: false
})
export class RolePipe implements PipeTransform {
  organization$: Observable<Organization | null> = inject(Store).select(
    OrganizationState.organization
  );

  transform(roleId: string): Observable<string> {
    return this.organization$.pipe(
      filterNullMap(),
      shareReplay(),
      map(org => {
        const orgRole = org.roles.find(r => r.roleId === roleId);
        return `${orgRole?.displayName ?? "[role  not found]"}`;
      })
    );
  }
}
